<template>
  <div class="" id="news" name="news">
    <div class="top">
      <NavTop activeIndex="2"></NavTop>
    </div>
    <!-- 内容 -->
    <div class="content">
      <!-- 日期 -->
      <div class="" style="
          display: flex;
          cursor: pointer;
          align-items: center;
          padding-left: 30px;
        ">
        <div class="" v-for="(item, index) in dateList" :key="index" style="margin: 0 15px; text-align: center"
          @click="changTab(index)">
          <div class="" style="color: #777">{{ item.week }}</div>
          <div :class="current == index ? 'active' : ''" style="font-size: 18px" v-if="index == 0">
            今天
          </div>
          <div :class="current == index ? 'active' : ''" style="font-size: 18px" v-else>
            {{ item.date }}
          </div>
          <div :class="current == index ? 'active1' : ''" style="
              width: 60px;
              height: 6px;
              background-color: #f0f1f6;
              margin: 0 auto;
              border-radius: 20px;
            "></div>
        </div>
      </div>
      <!-- 比赛列表 -->
      <div class="" style="margin-top: 30px" v-loading="loading">
        <div class="" v-for="(item, index) in list" :key="index" style="
            width: 1150px;
            background-color: #fff;
            border-radius: 2px;
            margin: 0 auto 15px;
            border-right: 6px solid #4b72f6;
            padding: 15px;
            box-sizing: border-box;
          ">

          <div class="" style="display: flex; align-items: center;justify-content: space-between;">
            <div class="" style="margin-left: 40px; width: 150px">
              <div class="" style="color: #777; font-size: 18px">
                {{ item.league_name }}
              </div>
              <div class="" style="font-size: 24px; font-weight: bold">
                {{ item.match_time.substring(10, 16) }}
              </div>
            </div>
            <div class="" style="">
              <div class="" style="display: flex; align-items: center; font-size: 16px">
                <img :src="item.home_team_logo_text" alt="" style="
                    width: 36px;
                    height: 36px;
                    display: block;
                    margin-right: 5px;
                  " />
                <div class="" style="width: 200px;font-size: 18px; ">
                  {{ item.home_team_name }}
                </div>
              </div>

              <div class="" style="
                  display: flex;
                  align-items: center;
                  margin-top: 10px;
                  font-size: 16px;
                ">
                <img :src="item.away_team_logo_text" alt="" style="
                    width: 36px;
                    height: 36px;
                    display: block;
                    margin-right: 5px;
                  " />
                <div class="" style="width: 200px;font-size: 18px; ">
                  {{ item.away_team_name }}
                </div>
              </div>

            </div>
            <div class=""
              style="display: flex;align-items: center; width: 500px; justify-content: space-between; margin-left: 20px;">
              <div class="" @click="leftSlide(index)" v-if="item.anchor_list.length > 5">
                <i class="el-icon-arrow-left" style="font-size: 40px; color: #999"></i>
              </div>
              <div class="" style="flex: 1">
                <div class="scroll_wrapper1"
                  style="display: flex;align-items: center; overflow-x: scroll;width: 450px;margin: 0 auto;"
                  ref="wrapperCon">
                  <div class="" v-for="(ite, ind) in item.anchor_list" :key="ind" style="margin: 0 25px"
                    @click="goDetail(ite)">
                    <div class="" style="
                        display: block;
                        width: 56px;
                        height: 56px;
                        border-radius: 50%;
                        position: relative;
                      ">
                      <img :src="baseUrl + ite.avatar" alt="" style="
                          display: block;
                          width: 56px;
                          height: 56px;
                          border-radius: 50%;
                        " />
                      <img src="../assets/images/live.png" alt="" style="
                          display: block;
                          width: 28px;
                          height: 16px;
                          position: absolute;
                          bottom: 0;
                          left: 14px;
                        " v-if="ite.live_status == 1" />
                    </div>
                    <div class="" style="color: #777; text-align: center">
                      {{ ite.nickname }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="" @click="rightSlide(index)" v-if="item.anchor_list.length > 5">
                <i class="el-icon-arrow-right" style="font-size: 40px; color: #999"></i>
              </div>
            </div>
            <div class="">
              <div class="" style="text-align: right; font-size: 18px" v-if="item.live_status == 1">
                直播中...
              </div>
              <div class="" style="display: flex; justify-content: end" v-if="item.live_status == 0">
                <div class="" style="
                background-color: #4b72f6;
                color: #fff;
                padding: 0 20px;
                border-radius: 60px;font-size: 18px
              " @click="goyuyue(item)" v-if="!item.is_reservation">
                  预约
                </div>
                <div class="" style="
                background-color: #eee;
                color: #333;
                padding: 0 20px;
                border-radius: 60px;font-size: 18px
              " v-else @click="qxyuyue(item)">
                  已预约
                </div>
              </div>
              <div class="" style="text-align: right; font-size: 18px" v-if="item.live_status == 2">
                已结束
              </div>
            </div>
          </div>
        </div>



        <div class="" style="display: flex;justify-content: center;" v-if="total > 10">
          <el-pagination layout="prev, pager, next" :total="total" background @prev-click="prevZhibo"
            @next-click="nextZhibo" @current-change="currentZhibbo">
          </el-pagination>

        </div>



      </div>
    </div>
  </div>
</template>
<script>
import NavTop from "../components/NavTopWhit.vue";
import { getsaichenglistPage, getConfreservationig } from "../api/user";
export default {
  components: {
    NavTop,
  },
  data() {
    return {
      timer: null, // 定时器（方便清除）
      current: 0,
      dateList: [],
      list: [],
      time: "",
      loading: false,
      total: 0,
      page: 1

    };
  },
  created() {
    this.dateList = [];
    this.getDateList();
    this.getList();
  },
  methods: {
    currentZhibbo(e) {
      console.log(e);
      this.page = e
      this.getList();

    },
    prevZhibo(e) {
      console.log(e);
      this.page = e
      this.getList();

    },
    nextZhibo(e) {
      console.log(e);
      this.page = e
      this.getList();

    },
    goDetail(item) {
      this.$router.push({
        path: "/details",
        query: {
          userId: item.id
        },
      });

    },
    godetail1(id) {
      this.$router.push({
        path: "/matchDEtail",
        query: {
          id,
        },
      });
    },
    changTab(index) {
      this.page = 1
      this.current = index;
      this.time = this.dateList[index].time;
      this.getList();
    },
    getList() {
      this.loading = true;
      getsaichenglistPage({
        date: this.time,
        page: this.page,
        limit: 10
      }).then((res) => {
        this.list = res.data.data
        this.total = res.data.total
        this.loading = false;
      });
    },
    getDateList() {
      this.dateList=[]
      const days = [
        "星期日",
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六",
      ];
      let today = new Date()
      console.log('当前',today);
      
      let obj = {};
      obj = {
        date: today.toLocaleDateString().slice(5, 10),
        week: days[today.getDay()],
        time: today.toLocaleDateString().slice(0, 10),
      };
      this.dateList.push(obj);
      this.time = obj.time;
      let day1 = new Date(today);
      day1.setDate(today.getDate() + 1);
      obj = {
        date: day1.toLocaleDateString().slice(5, 10),
        week: days[day1.getDay()],
        time: day1.toLocaleDateString().slice(0, 10),
      };
      this.dateList.push(obj);
      let day2 = new Date(today);
      day2.setDate(today.getDate() + 2);
      obj = {
        date: day2.toLocaleDateString().slice(5, 10),
        week: days[day2.getDay()],
        time: day2.toLocaleDateString().slice(0, 10),
      };
      this.dateList.push(obj);
      let day3 = new Date(today);
      day3.setDate(today.getDate() + 3);
      obj = {
        date: day3.toLocaleDateString().slice(5, 10),
        week: days[day3.getDay()],
        time: day3.toLocaleDateString().slice(0, 10),
      };
      this.dateList.push(obj);
      let day4 = new Date(today);
      day4.setDate(today.getDate() + 4);
      obj = {
        date: day4.toLocaleDateString().slice(5, 10),
        week: days[day4.getDay()],
        time: day4.toLocaleDateString().slice(0, 10),
      };
      this.dateList.push(obj);

      let day6 = new Date(today);
      day6.setDate(today.getDate() + 5);
      obj = {
        date: day6.toLocaleDateString().slice(5, 10),
        week: days[day6.getDay()],
        time: day6.toLocaleDateString().slice(0, 10),
      };
      this.dateList.push(obj);

      let day7 = new Date(today);
      day7.setDate(today.getDate() + 6);
      obj = {
        date: day7.toLocaleDateString().slice(5, 10),
        week: days[day7.getDay()],
        time: day7.toLocaleDateString().slice(0, 10),
      };
      this.dateList.push(obj);
      console.log(obj);
      console.log(this.dateList);
    },

    // 左箭头
    leftSlide(item) {
      // 保存滚动盒子左侧已滚动的距离
      let left = this.$refs.wrapperCon[item].scrollLeft;
      console.log(this.$refs.wrapperCon[item], "left");
      let num = 0;
      clearInterval(this.timer);
      this.timer = null;
      this.timer = setInterval(() => {
        //   !left:已经滚动到最左侧
        //   一次性滚动距离（可调节）
        if (!left || num >= 260) {
          // 停止滚动
          clearInterval(this.timer);
          this.timer = null;
          return;
        }
        // 给滚动盒子元素赋值向左滚动距离
        this.$refs.wrapperCon[item].scrollLeft -= 10;
        // 保存向左滚动距离（方便判断一次性滚动多少距离）
        num += 30;
      }, 20);
      // 20：速度（可调节）
    },
    // 右箭头
    rightSlide(item) {
      console.log("发改委复合物", this.$refs.wrapperCon[item], item);

      console.log(4984);
      // 保存滚动盒子左侧已滚动的距离
      let left = this.$refs.wrapperCon[item].scrollLeft;
      console.log(this.$refs.wrapperCon[item], "left");
      // 保存元素的整体宽度
      let scrollWidth = this.$refs.wrapperCon[item].scrollWidth;
      // 保存元素的可见宽度
      let clientWidth = this.$refs.wrapperCon[item].clientWidth;
      let num = 0;
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        // 已经滚动距离+可见宽度
        // left+clientWidth>=scrollWidth：滚动到最右侧
        // num>=300一次性滚动距离
        if (left + clientWidth >= scrollWidth || num >= 260) {
          clearInterval(this.timer);
          return;
        }
        // 给滚动盒子元素赋值向左滚动距离
        this.$refs.wrapperCon[item].scrollLeft += 10;
        // 保存向左滚动距离（方便判断一次性滚动多少距离）
        num += 30;
      }, 20);
      // 20：速度（可调节）
    },
    goyuyue(item) {
      getConfreservationig({
        id: item.id,
        type: 1
      }).then((res) => {
        // if (res.code == 1) {
        //   item.hasLive=1
        // }
        this.getList();
      });
    },
    qxyuyue(item) {
      getConfreservationig({
        id: item.id,
        type: 0
      }).then((res) => {
        if (res.code == 1) {
          item.is_reservation = false
        }
      });
    },
  },
};
</script>

<style scoped>
.content {
  width: 1200px;
  margin: 120px auto 30px;
}

.active {
  font-size: 24px !important;
}

.active1 {
  background-color: #4b72f6 !important;
}

.left_btn,
.right_btn {
  font-size: 30px;
  cursor: pointer;
  margin: -10px 5px 0;
}

#click-scroll-X {
  display: flex;
  align-items: center;
}

.scroll_wrapper {
  width: 290px;
  overflow: scroll;
  padding-bottom: 10px;
}

.scroll_list {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.item {
  cursor: pointer;
  width: 50px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #ccc;
  border-radius: 3px;
  box-sizing: border-box;
  flex-shrink: 0;
  margin: 0 2px;
}

/*隐藏滚动条*/
.scroll_wrapper1::-webkit-scrollbar {
  display: none;
}

.lveing:hover {
  background-color: red !important;
}
</style>
